import {
  LOAD_DEVICES,
  LOAD_DEVICES_SUCCESS,
  LOAD_DEVICES_ERROR,
} from "../Types/devices.constants";

const INITIAL_STATE = {
  loading: false,
  devices: [],
  error: null,
};

export const devicesListReducer = (state = INITIAL_STATE, action: any) => {
  switch (action.type) {
    case LOAD_DEVICES:
      return { ...state, loading: true, devices: [] };
    case LOAD_DEVICES_SUCCESS:
      return {
        ...state,
        loading: false,
        devices: action.payload,
      };
    case LOAD_DEVICES_ERROR:
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
};
